/**
 * YOONITE application server
 *
 * (c) 2019 FSZ GmbH
 * All rights reserved.
 */
import Joi from '~/shared/src/utilities/joiExtended';

export const titleSchema = Joi.string()
                              .description( 'The title of the panel shown on the tab.' );

export const iconClsSchema = Joi.string()
                                .description( 'The icon for the panel shown on the tab.' );

export const panelSchema = Joi.object( {
                                  title  : titleSchema,
                                  iconCls: iconClsSchema
                              } )
                              .description( 'The full panel schema.' );
